<script setup>
// core
import {useRouter} from "vue-router";

const router = useRouter()

const goToActivation = () => router.push({name: 'TelephonyActivation'})
</script>

<template>
    <div class="empty">
        <span class="empty__icon">
            <i class="bi bi-telephone-outbound"></i>
        </span>

        <p class="empty__title">{{ $t('telephony.calls_history.empty.title') }}</p>
        <p class="empty__text">{{ $t('telephony.calls_history.empty.text') }}</p>

        <button type="button" class="empty__button" @click="goToActivation">
            <i class="bi bi-telephone-plus"></i>
            {{ $t('telephony.calls_history.empty.button') }}
        </button>
    </div>
</template>

<style scoped lang="scss">
.empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;

    min-height: 320px;
    padding: 40px 20px;
    box-sizing: border-box;

    &__icon {
        width: 92px;
        height: 92px;
        margin-bottom: 12px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 50%;
        background: var(--block-color);
        color: var(--general-color);

        i {
            font-size: 34px;
            line-height: 1;
        }
    }

    &__title {
        margin: 0;
        font-family: 'Gilroy', sans-serif;
        font-size: 18px;
        font-weight: 700;
        line-height: 25px;
        text-align: center;
        color: var(--text-color);
    }

    &__text {
        margin: 0;
        font-family: 'Gilroy', sans-serif;
        font-size: 15px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: var(--text-third-color);
    }

    // same as .hiw__connect in SettingsHowItWorks
    &__button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        height: 43px;
        min-width: 0;
        max-width: none;
        margin-top: 16px;
        padding: 0 16px;

        border: 1px solid #7A70DF;
        border-radius: 9px;
        background: #ffffff;
        color: #7A70DF;
        cursor: pointer;
        transition: 0.25s;

        font-family: 'Gilroy', sans-serif;
        font-size: 15px;
        font-weight: 600;
        line-height: 17px;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        white-space: nowrap;

        i {
            font-size: 16px;
        }

        &:hover {
            background: #7A70DF;
            color: #ffffff;
        }
    }

    @media screen and (max-width: 680px) {
        min-height: 260px;
        padding: 24px 15px;

        &__button {
            width: 100%;
            white-space: normal;
        }
    }
}
</style>
